// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"c7b8d27e","155":"b9790cd1","239":"e01e0f70","453":"89b24f0a","455":"c4d156e8","977":"d299551f"}[chunkId] + ".chunk.js";
};